import React, { Component } from 'react';

import BeWise_Header from './header';
import BeWise_Footer from './footer';
import BeWise_SideBar from './sideBar';

import { Helmet } from 'react-helmet';

class AdminLayout extends Component {

    constructor(props) {
        super(props);
        this.state = {
			auth_data: JSON.parse(localStorage.getItem("user_data"))
        };
    }

    render() {

	return ( 
		<div className="App container-scroller bewiseui">
		{this.state.auth_data.role==3 && 
			        <Helmet>
					<title>BeWise Partner - Dashboard</title>
					<meta name="description" content={'BeWise partners with educators to enhance education. Learn more about our collaborative efforts and programs by visiting our website.'} />
					</Helmet>
		}
		<BeWise_Header/>
		<div class="container-fluid page-body-wrapper">
		<BeWise_SideBar/>
		<div class="main-panel">
			<div class="content-wrapper">
				{this.props.children}
			</div>
			<BeWise_Footer/>
		</div>
		</div>
		</div>

	)

	}

}



export default AdminLayout;


// WEBPACK FOOTER //
// ./src/components/bewise/layout.jsx